import { type FC } from 'react';

import { Icon, type IconProps, type IconTypes } from '@vakantiesnl/components/src/atoms/Icon';
import { Typography } from '@vakantiesnl/components/src/atoms/Typography';

import { useCustomStyles } from './OfferDetails.style';

export type OfferItemProps = {
	/** Title of the offer item to show */
	title: string;
	/** Icon type of the offer item to show */
	iconType: IconTypes;
	/** Optional styling variant */
	variant?: 'regular' | 'bold';
	/** Classname to pass through to the element */
	className?: string;
	/** Cy element to test with */
	dataCy?: string;
	iconSize?: IconProps['size'];
};

export const OfferItem: FC<OfferItemProps> = ({
	title,
	iconType,
	variant = 'regular',
	className,
	dataCy,
	iconSize,
}) => {
	const { classes, cx } = useCustomStyles();

	return (
		<div className={cx(classes.offerItem, className)} data-cy={dataCy}>
			<Icon type={iconType} size={iconSize} />
			<Typography
				variant="bodySm"
				as="p"
				className={cx(classes.title, { [classes.boldTitle]: variant === 'bold' })}
			>
				{title}
			</Typography>
		</div>
	);
};
